export default {
    getItem(key) {
        let userInfoStr = localStorage.getItem('user_info')
        if (userInfoStr && key !== 'lang' && key !== 'user_info' && !key.includes('ftth')&& !key.includes('appCode')&& !key.includes('onConfirmLogout')) {
            let userInfo = JSON.parse(userInfoStr)
            let fullKey = key + '_' + userInfo['isdn']
            return localStorage.getItem(fullKey)
        }

        return localStorage.getItem(key)
    },
    setItem(key, value) {
        let userInfoStr = localStorage.getItem('user_info')
        if (userInfoStr && key !== 'lang' && key !== 'user_info' && !key.includes('ftth')&& !key.includes('appCode')&& !key.includes('onConfirmLogout')) {
            let userInfo = JSON.parse(userInfoStr)
            let fullKey = key + '_' + userInfo['isdn']
            localStorage.setItem(fullKey, value)
        } else {
            localStorage.setItem(key, value)
        }
    },
    removeItem(key) {
        let userInfoStr = localStorage.getItem('user_info')
        if (userInfoStr) {
            let userInfo = JSON.parse(userInfoStr)
            let fullKey = key + '_' + userInfo['isdn']
            localStorage.removeItem(fullKey)
        }
        if (localStorage.getItem(key)) {
            localStorage.removeItem(key)
        }
    },
    removeAll() {
        const excludeKeys = ['lang', 'favourite_list', 'features'];

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            const shouldExclude = excludeKeys.some(prefix => key.startsWith(prefix));
            if (!shouldExclude) {
                localStorage.removeItem(key);
                i--; // vì localStorage.length thay đổi sau khi remove
            }
        }
    }

}